import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Footer from './components/Footer';
import NavBar from './components/NavBar';
import Hero1 from './components/Hero1';
import ContactUs from './components/ContactUs';
import About from './components/About';
import WhatDoWeDo from './components/WhatDoWeDo';
import Projects from './components/Projects';
import Clients from './components/Clients';
import WhyUs from './components/WhyUs';
import OurProcess from './components/OurProcess';
import { setLanguage } from './lang';
import GameDemo from './components/GameDemo';


function getInitialLanguage() {
  const savedLang = localStorage.getItem("lang");
  if (savedLang) return savedLang;

  const browserLang = navigator.language || navigator.userLanguage;
  const detectedLang = browserLang.startsWith("sl") ? "sl" : "en";
  localStorage.setItem("lang", detectedLang);
  return detectedLang;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <App /> */}
    <Hero1/>
    <NavBar/>
    <main style={{flex:1, minHeight:"1000px"}}>
      <About/>
      <WhatDoWeDo/>
      {/* <WhyUs/> */}
      <OurProcess/>
      <Projects/>
      <GameDemo/>
      <Clients/>
      <ContactUs/>
    </main>
    <Footer/>
  </React.StrictMode>
);
const lang = getInitialLanguage();
setTimeout(() => setLanguage(lang), 0);

window.changeLang = (newLang) => {
  localStorage.setItem("lang", newLang);
  setLanguage(newLang);
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
